import React, { useState, useEffect } from "react";
import { Spinner, MrSelect } from "mr_react_framework";
import { useDispatch, useSelector } from "react-redux";
import {
  appRegionSelector,
  currentUserSelector,
} from "/src/views/Auth/Login/selector";
import { hasSyllabusItemsInSegments, checkMob } from "/src/lib/utils/helperMethods";
import { Col, Empty, Row, Tabs } from "antd";
import { actions as experienceActions } from "/src/views/Experiences/redux";
import ExperienceAnalyticsSummary from "./ExperienceAnalyticsSummary";
import ExperienceAnalyticsQuestions from "./ExperienceAnalyticsQuestions";
import { activeAdjustedExperienceSelector } from "/src/views/Experiences/selector";
import ExperienceAnalyticsTags from "./ExperienceAnalyticsTags";
import MrTranslate, { useTranslate } from "/src/lib/MrTranslate/MrTranslate";
import "./ExperienceAnalytics.scss";
import { syllabusTopicsSelector } from "/src/App/genericSelector";
import { activeSegmentSelector, segmentsSelector } from "/src/views/Segments/selector";
import SelectOrgDropdown from "/src/components/AppSpecific/SelectOrg/SelectOrgDropdown";

const SelectGroupFilter = MrSelect({
  config: {
    processData: (data, props) => {
      console.log("data select groups", data);
      console.log("props select groups", props);
      return data.map((item) => {
        console.log("class selector item", item);
        return {label: item.label, value: item.value};
      });
    },
    searchApi: false,
    widgetConfig: {
      showSearch: false,
      filterOption: true,
      maxTagCount: 'responsive',
      optionFilterProp: "label",
      placeholder: <MrTranslate id={"ExperienceAnalytics.all_classes"} />,
      allowClear: true,
      mode: "multiple"
    },
  }
})

export const drawTopLineLabels = (shouldShowPercentage) => {
  return {
    afterDatasetsDraw(chart) {
      const { ctx, data, scales } = chart;
      const dataset = data.datasets[0].data;
      ctx.font = '12px sans-serif';
      ctx.fillStyle = 'black';
      ctx.textAlign = 'center';

      dataset.forEach((value, index) => {
        const xPosition = scales.x.getPixelForValue(index);
        const yPosition = scales.y.getPixelForValue(value);
        if ((!shouldShowPercentage && value !== 0) || (shouldShowPercentage && value !== '0.0')) {
          ctx.fillText(`${value}${shouldShowPercentage ? '%' : ''}`, xPosition, yPosition - 5);
        }
      });
    }
  }
}

const ExperienceAnalytics = (props) => {
  // const {  } = props;
  const currentUser = useSelector(currentUserSelector());
  const activeExperience = useSelector(activeAdjustedExperienceSelector());
  const mrIntl = useTranslate()
  const dispatch = useDispatch();
  const segments = useSelector(segmentsSelector());
  const isSyllabusTopicTagged = hasSyllabusItemsInSegments(segments)
  let groups = activeExperience.groups || []
  const shouldShowOrgFilter = currentUser.org && currentUser.org.org_type === "district" && currentUser.role === "qb_author";
  const [selectedGroupIds, setSelectedGroupIds] = useState([])
  const [selectedTab, setSelectedTab] = useState("summary")
  const [selectedOrgIds, setSelectedOrgIds] = useState([])
  
  let groupOptions = []
  if (groups && groups.length > 0) {
    groups.forEach((g, i) => {
      console.log("groupOptions", g)
      groupOptions.push({ label: g.name, value: g.id })
    })
  }
  const showGroupFilter = groupOptions.length > 0
  console.log("ExperienceAnalytics unmount", segments, isSyllabusTopicTagged);

  useEffect(() => {
    const successObj = [
      { type: "summary", data: [] },
      { type: "questions", data: [] },
      { type: "tags", data: [] }
    ];
  
    return () => {
      successObj.forEach((obj) => {
        dispatch(experienceActions.getAnalyticsSuccess(obj));
      });
    };
  }, []);

  const fetchAnalytics = (groupIds, tab, orgIds) => {
    dispatch(experienceActions.getAnalytics({ experience_id: activeExperience.id, type: tab, group_ids: [...groupIds], by_org_ids: [...orgIds] }))
  }

  const handleTabChange = (groupIds, tab, orgIds) => {
    setSelectedTab(tab)
    fetchAnalytics(groupIds, tab, orgIds)
  }

  let orgsFilter = (
    <SelectOrgDropdown
      key="orgs-select"
      value={selectedOrgIds}
      onChange={(value) => {
        setSelectedOrgIds(value)
        fetchAnalytics(selectedGroupIds, selectedTab, value)
      }}
      config={{
        params: {
          by_parent_id: currentUser.org.id,
          unarchived: true,
          with_nested_children: true,
          should_serialize: true,
        },
        widgetConfig: {
          maxTagCount: 'responsive',
          placeholder: "Select school",
          mode: "multiple",
          style: { width: '200px' }
        }
      }}
    />
  );

  const tabBarExtraContent = {
    right: (
      <Row gutter={5} justify="end" align="middle" className="experience-analytics-filter">
        {showGroupFilter && (
          <Col>
            <SelectGroupFilter
              key="experience-analytics-group-filter"
              dropdownMatchSelectWidth={false}
              value={selectedGroupIds}
              onChange={(value) => {
                setSelectedGroupIds(value);
                fetchAnalytics(value, selectedTab, selectedOrgIds);
              }}
              className="experience-analytics-group-filter"
              config={{ widgetConfig: { options: groupOptions } }}
            />
          </Col>
        )}
        {shouldShowOrgFilter && 
        <Col>
          {orgsFilter}
        </Col>
        }
      </Row>
    ),
  };
 
  return (
    <React.Fragment>
      {/* {isFirebaseTokenLoading && <Spinner />} */}
      <Row className="experience-analytics-container">
        <Col span={16} offset={4}>
          <Tabs defaultActiveKey="1" centered="true" className="custom-tabs-pills" tabBarExtraContent={tabBarExtraContent}  onChange={(key) => handleTabChange(selectedGroupIds, key, selectedOrgIds )}>
            <Tabs.TabPane tab={mrIntl("ExperienceAnalytics.summary")} key="summary">
              <ExperienceAnalyticsSummary />
            </Tabs.TabPane>
            {/* {activeExperience.settings["grading_setting"] === "per_question" && <Tabs.TabPane tab={mrIntl("ExperienceAnalytics.questions")} key="2">
              <ExperienceAnalyticsQuestions />
            </Tabs.TabPane>} */}
            <Tabs.TabPane tab={mrIntl("ExperienceAnalytics.questions")} key="questions">
              <ExperienceAnalyticsQuestions />
            </Tabs.TabPane>
            {(activeExperience.settings["grading_setting"] === "per_question" && isSyllabusTopicTagged) && <Tabs.TabPane tab={mrIntl("ExperienceAnalytics.standards")} key="tags">
              <ExperienceAnalyticsTags />
              {/* <Empty description={mrIntl("ExperienceAnalytics.no_data")} /> */}
            </Tabs.TabPane>}
          </Tabs>
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default ExperienceAnalytics;
